/**
 * Route for the requisition controls screen (P45 U64, FSD 4.2.1). INT spreads
 * `REQUISITION_CONTROL_ROUTES` into `PROCUREMENT_ROUTES` (routes.ts is shared by
 * several parallel packets) and adds the nav entry. Literal path string (R3).
 */

import type { RouteRecordRaw } from 'vue-router'

export const REQUISITION_CONTROL_ROUTES: RouteRecordRaw[] = [
  {
    path: '/procurement/requisition-controls',
    name: 'procurement-requisition-controls',
    component: () => import('@/modules/procurement/category-policies/RequisitionControlsView.vue'),
    meta: {
      titleKey: 'procurement.u64.controls.title',
      permission: 'procurement.category_policy.read',
    },
  },
]
